import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import AppSubPage from "../AppSubPage/AppSubPage";
import AppPageTitle from "../AppPageTitle/AppPageTitle";
import OverlayBackButton from "../StyledComponents/OverlayBackButton";
import UserJourneyOverview from "../UserJourneyOverview/UserJourneyOverview";
import Path from "src/constants/path";
import UserJourneyBloc from "../UserJourneyOverview/UserJourneyBloc";
import { useBloc } from "src/state/state";
import UserCubit from "src/state/UserCubit/UserCubit";
import Loader from "../Loader/Loader";
import { createAppPath } from "src/lib/createAppPath";
import RedirectWithQueryParams from "../RedirectWithQueryParams/RedirectWithQueryParams";

// handle redirect from path-to-healthy-weight to journey
const RedirectPathToHealthyWeightToJourney = () => {
  const location = useLocation();

  const { search } = location;
  const { hash } = location;

  const basePath = `${createAppPath(Path.myPlan as Path)}/${Path.journey}`;
  const newPath = `${basePath}${search}${hash}`;

  return <Navigate to={newPath} replace />;
};

const PlanRouter = () => {
  const [, userCubit] = useBloc(UserCubit);

  useEffect(() => {
    if (!userCubit.programMemberships) {
      void userCubit.getProfileAttributes();
    }
  }, [userCubit]);

  const program = UserJourneyBloc.getProgramFromMembership();
  const title = UserJourneyBloc.getTitleFromMembership();

  if (program === null || title === null) {
    return <Loader fixed active />;
  }

  return (
    <div>
      <Routes>
        <Route
          path={Path.journey}
          element={
            <AppSubPage>
              <OverlayBackButton show fallbackUrl={"/app/plan"} />
              <AppPageTitle title={title} />
              <UserJourneyOverview program={program} />
            </AppSubPage>
          }
        />
        <Route
          path="path-to-healthy-weight"
          element={<RedirectPathToHealthyWeightToJourney />}
        />
        {/* REDIRECT FOR UNKNOWN PATHS */}
        <Route
          path="*"
          element={<RedirectWithQueryParams to={createAppPath(Path.myPlan)} />}
        />
      </Routes>
    </div>
  );
};

export default PlanRouter;
